import { useEffect, useRef, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import PlansCard from './PlansCardTab/plansCard';
import { useGetPlanListByPatient, useGetVisitNotes } from '../hooks/useGetDataQuery';
import { BlockUI } from 'primereact/blockui';
import "./prescription.css"
import AddExercisesDialog from '../Utils/ExerciseDialog/addExercisesDialog';
import PatientDetailCard from './patientDetailCard';

import ControlPanel from './controlPanel';
import { useTranslation } from 'react-i18next';
import PatientHistory from './PatientHistroyTab/patientHistory';
import AddPatientDialog from '../Utils/AddPatientDialog/addPatientDialog';


const Prescription = () => {
    const {
        mutate: getPlanListByPatientMutation,
        data: planListByPatientMutationData,
        isSuccess: isSuccessPlanListByPatientMutation,
        isError: isErrorPlanListByPatientMutation,
    } = useGetPlanListByPatient();

    const {
        mutate: getVisitNotesMutation,
        data: visitNotesData,
        isSuccess: isSuccessVisitNotesMutation,
    } = useGetVisitNotes();

    const { t }: any = useOutletContext();
    const { patientNewList }: any = useOutletContext();
    const { setPatientList }: any = useOutletContext();

    const { i18n } = useTranslation();

    const [selectedPatient, setSelectedPatient] = useState<any>(JSON.parse(localStorage.getItem("patient") || '{}'));

    const [editPatientDialogVisible, setEditPatientDialogVisible] = useState<boolean>(false);

    const [firstPageRequest, setFirstPageRequest] = useState<any>(true)

    const [planList, setPlanList] = useState<any>([])

    const [blockUI, setBlockUI] = useState(true);

    const [exerciseDialogVisible, setExerciseDialogVisible] = useState<any>(selectedPatient.code ? false : true);

    const [tabIndex, setTabIndex] = useState<any>(0)

    const [planTimeLine, setPlanTimeLine] = useState<any>()

    const patientDetailOp = useRef<any>(null);

    const [rangeForCompletedPlans, setRangeForCompletedPlans] = useState<any>([null, null]);

    const [visitNoteList, setVisitNoteList] = useState<any>([])


    const shiftToUTC3 = (date: Date): Date => {
        const shifted = new Date(date);
        shifted.setHours(shifted.getHours() + 3);
        return shifted;
    };

    useEffect(() => {
        setBlockUI(true)
        if (!planTimeLine) {
            setPlanTimeLine(
                selectedPatient?.status === "Completed" ? t("completed") :
                    selectedPatient?.status === "NotStarted" ? t("upcoming") : t("ongoing")
            );
        }

        if (planTimeLine) {
            const today = new Date();
            const ninetyDaysAgo = new Date();
            ninetyDaysAgo.setDate(today.getDate() - 90);
            setRangeForCompletedPlans([ninetyDaysAgo, today]);

            getPlanListByPatientMutation(planTimeLine === t("completed") ?
                {
                    patientId: selectedPatient?.id,
                    planTimeLine: "Completed",
                    startTime: shiftToUTC3(rangeForCompletedPlans[0]),
                    endTime: shiftToUTC3(rangeForCompletedPlans[1])
                }
                :
                {
                    patientId: selectedPatient?.id,
                    planTimeLine: planTimeLine === t("ongoing") ? "InProgress" : "NotStarted"
                })
        }
    }, [planTimeLine]);

    useEffect(() => {
        if (planTimeLine) {
            if (planTimeLine === "Devam Eden" || planTimeLine === "Ongoing") {
                setPlanTimeLine(t("ongoing"));
            }
            else if (planTimeLine === "Tamamlandı" || planTimeLine === "Completed") {
                setPlanTimeLine(t("completed"));
            }
            else {
                setPlanTimeLine(t("upcoming"));
            }
        }
    }, [i18n.language]);

    useEffect(() => {
        if (rangeForCompletedPlans && !firstPageRequest && planTimeLine === t("completed")) {
            if (rangeForCompletedPlans[0] && rangeForCompletedPlans[1]) {
                setBlockUI(true)
                getPlanListByPatientMutation(
                    {
                        patientId: selectedPatient?.id,
                        planTimeLine: "Completed",
                        startTime: shiftToUTC3(rangeForCompletedPlans[0]),
                        endTime: shiftToUTC3(rangeForCompletedPlans[1])
                    })
            }
        }
    }, [rangeForCompletedPlans]);

    useEffect(() => {
        const patient = JSON.parse(localStorage.getItem("patient") || '{}')
        if (patient.id !== selectedPatient.id) {
            setBlockUI(true)
            getPlanListByPatientMutation({
                patientId: patient.id,
                offset: 0,
                planTimeLine: "InProgress",
            })
            setSelectedPatient(JSON.parse(localStorage.getItem("patient") || '{}'))
            setExerciseDialogVisible(patient.code ? false : true)
            setTabIndex(0)
            setPlanTimeLine(t("ongoing"));
        }
        getVisitNotesMutation(patient.id);
    }, [patientNewList]);

    useEffect(() => {
        if (isSuccessPlanListByPatientMutation) {
            const sortedData = planListByPatientMutationData?.data?.map((plan: any) => ({
                ...plan,
                exerciseList: plan.exerciseList?.map((exercise: any) => ({
                    ...exercise,
                    exerciseTimeLine: exercise.exerciseTimeLine?.sort((a: any, b: any) => 
                        new Date(a.dateWillBeDone).getTime() - new Date(b.dateWillBeDone).getTime()
                    )
                }))
            }));
            setPlanList(sortedData)
            setBlockUI(false);
            setFirstPageRequest(false);
        }
    }, [isSuccessPlanListByPatientMutation]);

    useEffect(() => {
        if (isErrorPlanListByPatientMutation) {
            setBlockUI(false);
            setFirstPageRequest(false);
        }
    }, [isErrorPlanListByPatientMutation]);

    useEffect(() => {
        if (isSuccessVisitNotesMutation) {
            if (visitNotesData.data) {
                const sortedVisits: any = [...visitNotesData?.data].sort(
                    (a, b) => new Date(b.visitDate).getTime() - new Date(a.visitDate).getTime()
                );

                setVisitNoteList(sortedVisits);
            }

        }
    }, [isSuccessVisitNotesMutation]);

    return (
        <BlockUI
            blocked={blockUI}
            fullScreen
            style={{ backgroundColor: "transparent" }}
            template={
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <dotlottie-player
                        src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                        background="transparent"
                        speed="1"
                        style={{ width: "3rem", height: "3rem" }}
                        loop
                        autoplay
                    />
                </div>
            }
        >
            {selectedPatient ? (
                <div className="flex flex-column justify-content-center gap-3">
                    <ControlPanel
                        t={t}
                        setExerciseDialogVisible={setExerciseDialogVisible}
                        tabIndex={tabIndex}
                        setTabIndex={setTabIndex}
                        selectedPatient={selectedPatient}
                        patientDetailOp={patientDetailOp} />
                    {tabIndex === 0 &&
                        <>
                            <PlansCard
                                t={t}
                                planList={planList}
                                setPlanList={setPlanList}
                                planTimeLine={planTimeLine}
                                setPlanTimeLine={setPlanTimeLine}
                                rangeForCompletedPlans={rangeForCompletedPlans}
                                setRangeForCompletedPlans={setRangeForCompletedPlans}
                                selectedPatient={selectedPatient}
                            />
                        </>
                    }

                    {tabIndex === 1 &&
                        <>
                            <PatientHistory
                                selectedPatient={selectedPatient}
                                visitNoteList={visitNoteList}
                                setVisitNoteList={setVisitNoteList}
                                t={t} />
                        </>
                    }

                    <PatientDetailCard
                        t={t}
                        selectedPatient={selectedPatient}
                        setExerciseDialogVisible={setExerciseDialogVisible}
                        visitNote={visitNoteList ? visitNoteList[0] : null}
                        patientDetailOp={patientDetailOp}
                        setEditPatientDialogVisible={setEditPatientDialogVisible}
                    />

                    <AddExercisesDialog t={t}
                        selectedPatient={selectedPatient}
                        exerciseDialogVisible={exerciseDialogVisible}
                        setExerciseDialogVisible={setExerciseDialogVisible}
                        setSelectedPatient={setSelectedPatient} />

                    <AddPatientDialog
                        t={t}
                        addPatientDialogVisible={editPatientDialogVisible}
                        setAddPatientDialogVisible={setEditPatientDialogVisible}
                        selectedPatient={selectedPatient}
                        setSelectedPatient={setSelectedPatient}
                        isEditModeActive={true}
                        setPatientList={setPatientList}
                    />
                </div>
            ) : (
                <>
                </>
            )}
        </BlockUI>
    )
}

export default Prescription